














































































import Vue from 'vue';
import LearningTools from '@/tools/learning';
import BbTools from '@/tools/bluebird';
import Activity from '@/components/activity/Activity.vue';
import ActivityStatus from '@/components/activity/ActivityStatusText.vue';
import AccessibleButton from '@/components/ui/AccessibleButton.vue';
import BottomScores from '@/components/activity/BottomScores.vue';
import { Phrase, RapidTestResponse } from '@/store/types';
import shuffle from 'lodash.shuffle';

export default Vue.extend({
  components: {
    activity: Activity,
    'accessible-button': AccessibleButton,
    'activity-status': ActivityStatus,
    'bottom-scores': BottomScores,
  },
  props: [
    'videoPlayer',
    'quizPhrase',
    'activityIndex',
    'activityDataLength',
    'averageScore',
    'isRapidTest',
  ],
  data() {
    return {
      phrasesOnPageByDefault: 4,
      quizPhrases: new Array<Phrase>(),
      quizPhrasesNative: new Array<Phrase>(),
      selectedPhrase: null as Phrase | null,
      selectedPhraseNative: null as Phrase | null,
      playingAnswer: false,
      currentScore: 0,
      lockInput: false,
      nextQuestionResponse: null as RapidTestResponse | null,
      lastAnswerCorrect: false,
    };
  },
  mounted() {
    this.playingAnswer = false;
    if (!this.isRapidTest) {
      [this.quizPhrase.phrase] = this.quizPhrase.choices;
    }
    this.$nextTick(this.updateQuizPhrases);
  },
  computed: {
  },
  methods: {
    onPhrase(phrase: Phrase) {
      this.selectedPhrase = phrase;
      if (this.selectedPhraseNative) {
        this.checkAnswer();
      }
    },
    onPhraseNative(phraseNative: Phrase) {
      this.selectedPhraseNative = phraseNative;
      if (this.selectedPhrase) {
        this.checkAnswer();
      }
    },
    async checkAnswer() {
      if (this.selectedPhrase && this.selectedPhraseNative) {
        this.lastAnswerCorrect = false;

        let answerCorrect = this.selectedPhrase && this.selectedPhraseNative;

        if (this.isRapidTest) {
          this.lockInput = true;
          this.nextQuestionResponse = await LearningTools.setAnswerAndGetNextRapidTestPhrase(
            this.$store,
            this.$router,
            this.quizPhrase.quizType,
            this.selectedPhrase.word,
            this.selectedPhraseNative.word,
          );
          if (!this.nextQuestionResponse) {
            return;
          }
          answerCorrect = this.nextQuestionResponse.message === 'ok'
            || (this.nextQuestionResponse.message !== 'ok'
              && this.nextQuestionResponse.message !== 'ko');
          this.lockInput = false;
        }
        this.lastAnswerCorrect = answerCorrect;

        if (answerCorrect) {
          this.playingAnswer = true;
          (this.$refs.activityStatus as any).updateScore(1, '');
          await BbTools.sleepCancelable(LearningTools.TO_START_PLAYING, this.$store);
          this.quizPhrase.phrase = this.selectedPhrase;
          (this.$refs.activity as any).startPlaying();
        } else {
          this.playingAnswer = true;
          this.selectedPhraseNative.badge = true;
          (this.$refs.activityStatus as any).updateScore(0, '');
          this.currentScore -= 1 / this.quizPhrase.choices.length;
          if (this.currentScore < 0) {
            this.currentScore = 0;
          }
          await BbTools.sleepCancelable(LearningTools.TO_START_PLAYING, this.$store);
          this.selectedPhraseNative.badge = false;
          this.selectedPhraseNative = null;
          this.selectedPhrase = null;
          this.playingAnswer = false;
        }
      }
    },
    getPhraseText(phrase: Phrase) {
      if (this.$store.state.user.phoneticMode && phrase.phonetic && phrase.phonetic !== '') {
        return phrase.phonetic;
      }
      return phrase.word;
    },
    phraseClass(phrase: Phrase) {
      let result = 'pt-1 mb-2 matchlist-complete-item phrase-button';
      if (this.selectedPhrase && this.selectedPhrase.word === phrase.word) {
        if (this.selectedPhraseNative
          && (this.selectedPhrase.word === this.selectedPhraseNative.word
          || (this.isRapidTest && this.lastAnswerCorrect))) {
          result += ' green link--text';
        } else if (this.selectedPhraseNative !== null
          && this.selectedPhrase !== null && !this.lockInput) {
          result += ' red link--text';
        } else {
          result += ' primary link--text';
        }
      }
      return result;
    },
    phraseNativeClass(phraseNative: Phrase) {
      let result = 'pt-1 mb-2 matchlist-complete-item phrase-button';
      if (this.selectedPhraseNative && this.selectedPhraseNative.word === phraseNative.word) {
        if (this.selectedPhrase && (this.selectedPhraseNative.word === this.selectedPhrase.word
        || (this.isRapidTest && this.lastAnswerCorrect))) {
          result += ' green link--text';
        } else if (this.selectedPhraseNative !== null
          && this.selectedPhrase !== null && !this.lockInput) {
          result += ' red link--text';
        } else {
          result += ' primary link--text';
        }
      }
      return result;
    },
    updateQuizPhrases() {
      this.currentScore = 1;
      const quizPhrasesTemp: Array<Phrase> = [];
      const quizPhrasesNativeTemp: Array<Phrase> = [];
      this.quizPhrase.choices.forEach((phrase: Phrase) => {
        quizPhrasesTemp.push({ ...phrase, badge: false });
      });
      this.quizPhrase.nativeChoices.forEach((phrase: Phrase) => {
        quizPhrasesNativeTemp.push({ ...phrase, badge: false });
      });
      this.quizPhrases = quizPhrasesTemp;
      this.quizPhrasesNative = this.isRapidTest
        ? quizPhrasesNativeTemp : shuffle(quizPhrasesNativeTemp);
    },
    async audioPlayed() {
      this.playingAnswer = false;
      if (this.selectedPhrase) {
        this.quizPhrases.splice(this.quizPhrases.indexOf(this.selectedPhrase), 1);
      }
      if (this.selectedPhraseNative) {
        this.quizPhrasesNative.splice(this.quizPhrasesNative.indexOf(this.selectedPhraseNative), 1);
      }
      this.selectedPhrase = null;
      this.selectedPhraseNative = null;
      let quizCompleted = this.quizPhrases.length === 0;
      if (this.isRapidTest) {
        quizCompleted = this.nextQuestionResponse.message !== 'ok'
          && this.nextQuestionResponse.message !== 'ko';
      }
      if (quizCompleted) {
        this.$emit('onScoreResult', this.currentScore);
        if (this.$refs.activityStatus) {
          (this.$refs.activityStatus as any).updateScore(this.currentScore, '');
        }
        this.$emit('checkQuizEndOrNext', this.nextQuestionResponse);
      }
    },
  },
  beforeDestroy() {
    if (this.$store.state.sleepPromise) {
      this.$store.state.sleepPromise.cancel();
    }
  },
});
